
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.969 3H8v7H6V5.469C5.556 5.724 5.087 6 4.406 6V4c.494 0 1.25-.656 1.25-.656zM11 6h17v2H11V6zm-4.5 6C7.883 12 9 13.117 9 14.5c0 .481-.248 1.09-.75 1.5l.031.031-.125.094-.875.875H9v2H4v-1.625l.313-.281L7.001 14.5c0-.217-.283-.5-.5-.5s-.5.283-.5.5v.5h-2v-.5c0-1.383 1.117-2.5 2.5-2.5zm4.5 3h17v2H11v-2zm-7 6h4v1.469l-.125.25-.406.688C8.322 23.805 9 24.496 9 25.501c0 1.383-1.117 2.5-2.5 2.5H4v-2h2.5c.217 0 .5-.283.5-.5s-.283-.5-.5-.5H5v-1.375l.125-.219.25-.406H4v-2zm7 3h17v2H11v-2z"}})])
          )
        }
      }
    